import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  buttonWrapper: {
    position: 'relative',
    display: 'inline-block',
    marginTop: '12px',
  },
  dropdown: {
    position: 'absolute',
    bottom: '100%',
    left: 0,
    marginBottom: '4px',
    padding: '4px',
    listStyle: 'none',
    zIndex: 999,
    borderRadius: anatomy.borderRadiusS,
    backgroundColor: palette['grey-950'],
    border: `1px solid ${palette['grey-700']}`,
    minWidth: '178px',
    boxShadow: `0 4px 12px ${palette['darked-50']}`,
  },
  dropdownItem: {
    padding: 0,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    fontFamily: fonts.din2014Regular,
    color: palette['greyWhite'],
    borderRadius: anatomy.borderRadiusXs,
    ':hover': {
      backgroundColor: palette['grey-800'],
    },
  },
  dropdownItemDisabled: {
    cursor: 'not-allowed',
    color: palette['grey-700'],
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  dropdownButton: {
    background: 'none',
    border: 'none',
    padding: '8px 12px',
    color: 'inherit',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    textAlign: 'left',
  },
});
